document.addEventListener("DOMContentLoaded", onLoad);
document.addEventListener("shopify:section:load", onLoad);

function onLoad(e) {
  const urlParams = new URLSearchParams(window.location.search);
  
  if (urlParams.has('chat_popup')) {
    console.log(`chat_popup detected`)
    ChannelIO('showMessenger')
  }  
}